


































































import mixins, { ExtractVue } from '@/utils/mixins';
// mixins
import snackbar from '@/mixins/snackbar';
// providers
import { authProvider } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib';
import { Group } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib/types/model/userData';

import QuoteListXMLDialog from '@/components/quotes/QuoteListXMLDialog.vue';
import ALPage from '@/components/core/Page/ALPage.vue';

export default mixins(snackbar).extend({
  components: { QuoteListXMLDialog, ALPage },

  data() {
    return {
      search: this.$route.query.search
    };
  },

  computed: {
    authProvider(): any {
      return authProvider(this.$store);
    },

    isQuoteAdmin(): boolean {
      const userGroups: Group[] = this.authProvider.getCurrentUser.groups ?? [];

      const isQuoteAdmin = userGroups.find(
        ({ name }) => name === 'Quote Admin'
      );

      return Boolean(isQuoteAdmin);
    }
  },

  methods: {
    async openQuoteListXMLDialog() {
      const quoteListDialog = this.$refs.quoteListXMLDialog as InstanceType<
        typeof QuoteListXMLDialog
      >;
      quoteListDialog.open();
    },

    async openQuoteWizardFormDialog() {
      const { default: wizardFormDialog } = await import(
        '@/components/quotes/QuoteWizardFormDialog.vue'
      );

      if (wizardFormDialog) {
        const formDialog = this.$refs.QuoteWizardFormDialog as ExtractVue<
          typeof wizardFormDialog
        >;

        formDialog.open();
      } else {
        this.createSnack({
          color: 'warning darken-1',
          type: 'warning',
          right: true,
          useBtn: false,
          msg: 'Quote wizard module failed to load',
          btnText: 'Close',
          timeout: 6000,
          action: function() {}
        });
      }
    }
  }
});
